import SetCard from './SetCard';
import AddSetButton from './AddSetButton';
import SensorDetails from './SensorDetails';
import GetDataButton from './GetDataButton';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { cardSetAtom, isLoadingAtom } from 'pages/Qc/state';
import UploadFile from 'pages/OnBoarding/UploadFile';
import api from 'utils/api';

// =============================================================================
const APPBAR_HEIGHT = 40 + 94.5;
const SIDEBAR_HEIGHT = window.innerHeight - APPBAR_HEIGHT;

// =============================================================================
const side_drawer_wrapper_style = {
  height: '100%',
  width: '100%',
  boxShadow: '8px 0px 16px rgba(0, 0, 0, 0.16)',
  display: 'flex',
  flexDirection: 'column' as const,
  flexFlow: 'column',
  paddingBottom: 20
};

const card_wrapper_style = {
  display: 'flex',
  flexDirection: 'column' as const,
  marginBottom: 8,
  overflowY: 'scroll' as const,
  overflowX: 'hidden' as const
};

// =============================================================================
export default function SideDrawer() {
  const cardSet: any = useRecoilValue(cardSetAtom);
  const setIsLoading = useSetRecoilState(isLoadingAtom);

  return (
    <div style={side_drawer_wrapper_style}>
      <div style={{ padding: '16px' }}>
        <UploadFile
          accept='.csv'
          title='Upload QC'
          handleChange={async (e: React.ChangeEvent<HTMLInputElement>) => {
            const csvFile = e.target.files ? e.target.files[0] : null;
            if (csvFile) {
              try {
                setIsLoading(true);
                const fd = new FormData();
                fd.append('file', csvFile);
                await api.post('/api/rawData/qc/upload', fd, {
                  headers: {
                    'Content-Type': 'multipart/form-data'
                  }
                });
                alert('Successfully uploaded and updated QC data');
              } catch (err: any) {
                const msg =
                  err?.response?.data?.message ??
                  err?.message ??
                  'Upload failed. Please try again.';
                alert(msg);
              } finally {
                setIsLoading(false);
              }
            }
          }}
        />
      </div>
      <div style={card_wrapper_style}>
        {generateSetCard()}
        <div style={{ height: 8 }} />
      </div>
      {/* <div style={{flex: 1}}/> */}
      <div style={{ padding: '0 16px' }}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-around'
          }}
        >
          <AddSetButton />
          <GetDataButton />
        </div>
        <div style={{ height: 8 }} />
        <SensorDetails />
      </div>
    </div>
  );

  function generateSetCard() {
    return cardSet.map((item: any, index: any) => (
      <SetCard
        key={index}
        index={index}
        location={item.location}
        depth={item.depth}
        depths={item.depths}
        parameter={item.parameterDesc}
        isCruiseParam={item.isCruiseParam}
        isDcps={item.sensorId === 'dcps'}
      />
    ));
  }
}

// =============================================================================
